@if (url === '/carrinho') {
  <cart-main></cart-main>
}
@if (url === '/carrinho/listagem') {
  <cart-list></cart-list>
}
@if (url === '/carrinho/import') {
  <cart-import></cart-import>
}
